<div class="topdiv" >
    <label i18n="@@spmsUserReg" class="textColour">Object Groups</label>
    <span class="example-spacer"></span>
    <div *ngIf="addBtn" style="margin-top: 25px;" >
        <form novalidate [formGroup]='validations_form'>
            <div style="display: flex; justify-content: space-evenly;margin-bottom: 1.2rem;"class="row">
                <!-- <div class="col-3"></div> -->
                <div class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFormulaexpression">Object Group Name</mat-label>
                        <input title="Object Group Name" matInput type="text" placeholder="Object Group Name" formControlName="groupname"
                            [(ngModel)]="reportCreationData.groupname" maxlength="100" required>
                        <mat-error *ngFor="let validation of validation_messages.groupname">
                            <span
                                *ngIf="validations_form.get('groupname').hasError(validation.type) && (validations_form.get('groupname').dirty || validations_form.get('groupname').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div style="text-align: center;" class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERfirstname">Description</mat-label>
                        <input title="Description" matInput type="text" placeholder="Description" formControlName="description"
                            [(ngModel)]="reportCreationData.description" maxlength="100" required>
                        <mat-error *ngFor="let validation of validation_messages.description">
                            <span
                                *ngIf="validations_form.get('description').hasError(validation.type) && (validations_form.get('description').dirty || validations_form.get('description').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFormulaexpression">Source DNS for Metadata</mat-label>
                        <mat-select title="Source DNS for Metadata" [(ngModel)]="reportCreationData.sourceDNS"  formControlName="sourceDNS" required multiple
                            (closed)="onSelectionSourceDNS()">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let source of listOfSourceDNS"
                             [(value)]="source.vaultConfigMstrId">{{source.envName}}</mat-option>
                        </mat-select>
                        <mat-error *ngFor="let validation of validation_messages.sourceDNS">
                            <span
                                *ngIf="validations_form.get('sourceDNS').hasError(validation.type) && (validations_form.get('sourceDNS').dirty || validations_form.get('sourceDNS').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- ************************************************* -->
                <div  class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFormulaexpression">Group Extraction Type</mat-label>

                        <mat-select title="Group Extraction Type" [(ngModel)]="reportCreationData.groupExtractionType"  formControlName="groupExtractionType" required
                            (selectionChange)="onSelectionChange()">
                            <mat-option value="Full">Full</mat-option>
                            <mat-option value="Partial">Partial</mat-option>
                        </mat-select>
                        <mat-error *ngFor="let validation of validation_messages.groupExtractionType">
                            <span
                                *ngIf="validations_form.get('groupExtractionType').hasError(validation.type) && (validations_form.get('groupExtractionType').dirty || validations_form.get('groupExtractionType').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>



                <!-- *************************************************************** -->
                <!-- <div class="col-3"></div> -->

            </div>

            <div style="display: flex; justify-content: space-evenly;margin-bottom: 1.2rem;" class="row">
                <!-- <div class="col-3"></div> -->
                <div class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFormulaexpression">Partition By</mat-label>
                        <input title="Partition By" matInput type="text" placeholder="Partition By" formControlName="csvtojsoncsvpartitionname"
                            [(ngModel)]="reportCreationData.csvtojsoncsvpartitionname" maxlength="100" required>
                        <mat-error *ngFor="let validation of validation_messages.csvtojsoncsvpartitionname">
                            <span
                                *ngIf="validations_form.get('csvtojsoncsvpartitionname').hasError(validation.type) && (validations_form.get('csvtojsoncsvpartitionname').dirty || validations_form.get('csvtojsoncsvpartitionname').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div style="text-align: center;"class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERfirstname">Start Position</mat-label>
                        <input title="Start Position" matInput type="text" placeholder="Start Position" formControlName="csvtojsonpartitionsubstringstartposition"
                            [(ngModel)]="reportCreationData.csvtojsonpartitionsubstringstartposition " maxlength="100" required
                            onkeypress="return /[0-9]/i.test(event.key)">
                        <mat-error *ngFor="let validation of validation_messages.csvtojsonpartitionsubstringstartposition">
                            <span
                                *ngIf="validations_form.get('csvtojsonpartitionsubstringstartposition').hasError(validation.type) && (validations_form.get('csvtojsonpartitionsubstringstartposition').dirty || validations_form.get('csvtojsonpartitionsubstringstartposition').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div style="text-align: center;"class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label  i18n="@@TMSTAFFMASTERfirstname">Partition Length</mat-label>
                        <input title="Partition Length" matInput type="text"  placeholder="Partition Length" formControlName="csvtojsonpartitionsubstringlength"
                            [(ngModel)]="reportCreationData.csvtojsonpartitionsubstringlength" maxlength="100" required onkeypress="return /[0-9]/i.test(event.key)">
                        <mat-error *ngFor="let validation of validation_messages.csvtojsonpartitionsubstringlength" >

                            <span
                                *ngIf="validations_form.get('csvtojsonpartitionsubstringlength').hasError(validation.type) && (validations_form.get('csvtojsonpartitionsubstringlength').dirty || validations_form.get('csvtojsonpartitionsubstringlength').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div  class="col-3">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFormulaexpression">Set Split Required</mat-label>

                        <mat-select title="Set Split required" [(value)]="reportCreationData.setsSplitRequired"  formControlName="setsSplitRequired" required
                            (selectionChange)="onSelectionChange()">
                            <mat-option value="Yes">Yes</mat-option>
                            <mat-option value="No">No</mat-option>
                        </mat-select>
                        <mat-error *ngFor="let validation of validation_messages.setsSplitRequired">
                            <span
                                *ngIf="validations_form.get('setsSplitRequired').hasError(validation.type) && (validations_form.get('setsSplitRequired').dirty || validations_form.get('setsSplitRequired').touched)">
                                {{ validation.message }}
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>


                <!-- ************************************************* -->


                <!-- *************************************************************** -->
                <!-- <div class="col-3"></div> -->

            </div>

        <!-- ================================================================== -->



        <!-- @modified by Aman Singh
        @date 20-05-2024
        @desc Added 2 new fields at obejct group level (extraction method and field from objectmetadata)
        -->

        <div style="display: flex; justify-content: space-evenly;margin-bottom: 1.2rem;"class="row">
                   <div  class="col-3">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Extraction Method</mat-label>
                    <mat-select title="Extraction Method" [(ngModel)]="reportCreationData.extractionsource"  formControlName="extractionsource" required
                        (selectionChange)="onSelectionChange()">
                        <mat-option value="Loader">Loader</mat-option>
                        <mat-option value="VQL">VQL</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.extractionsource">
                        <span
                            *ngIf="validations_form.get('extractionsource').hasError(validation.type) && (validations_form.get('extractionsource').dirty || validations_form.get('extractionsource').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
            <div  class="col-3">
                <mat-form-field appearance="outline">

                    <mat-label i18n="@@RCFormulaexpression">CSV Extraction Method</mat-label>

                    <mat-select title="CSV Extraction Method" [(ngModel)]="reportCreationData.csvextractionsource" formControlName="csvextractionsource"
                            required (selectionChange)="onSelectionChange()">
                            <mat-option value="Loader">Loader</mat-option>
                            <mat-option value="VQL">VQL</mat-option>
                        </mat-select>
                        <mat-error *ngFor="let validation of validation_messages.csvextractionsource">
                            <span
                            *ngIf="validations_form.get('csvextractionsource')?.hasError(validation.type) && (validations_form.get('csvextractionsource')?.dirty || validations_form.get('csvextractionsource')?.touched)">
                     {{ validation.message }}
                            </span>
                        </mat-error>
                </mat-form-field>
            </div>
             <div  class="col-3">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">Fields From Objectmetadata</mat-label>

                    <mat-select title="Fields From Objectmetadata" [(ngModel)]="reportCreationData.fieldsfromobjectmetadata"  formControlName="fieldsfromobjectmetadata" required
                        (selectionChange)="onSelectionChange()">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.fieldsfromobjectmetadata">
                        <span
                            *ngIf="validations_form.get('fieldsfromobjectmetadata').hasError(validation.type) && (validations_form.get('fieldsfromobjectmetadata').dirty || validations_form.get('fieldsfromobjectmetadata').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>

            <div  class="col-3">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFormulaexpression">splitBy</mat-label>
 
                    <mat-select title="splitBy" [(ngModel)]="reportCreationData.splitby"  formControlName="splitby" required
                        (selectionChange)="onSelectionChange()">
                        <mat-option value="id">id</mat-option>
                        <mat-option value="case_number__v">case_number__v</mat-option>
                        <mat-option value="local_case__v">local_case__v</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.splitby">
                        <span
                            *ngIf="validations_form.get('splitby').hasError(validation.type) && (validations_form.get('splitby').dirty || validations_form.get('splitby').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>




        </div>

        <!-- ======================================================================== -->



        </form>
    </div>

    <div *ngIf="addBtn" class="row" style=" margin-left: 3px;">
        <!-- <div class="col-2" style="border: 1px solid green;"  ></div> -->
        <div style="width: 18%; margin: 2px;">
            <div class="seperateDiv">
                <ag-grid-angular id="Grid"
                    class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
                    [columnDefs]="columnDefsForObjects" [animateRows]="true" [defaultColDef]="defaultColDef"
                    [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true"
                    [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35"
                    [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true"
                    [debug]="true" (gridReady)="onGridReadyForObjects($event)" (rowSelected)="onRowSelected($event)"
                    [hidden]="!true">
                </ag-grid-angular>
            </div>
        </div>


        <div *ngIf="addBtn" style="width: 2%;margin: auto 5px;margin-right: 12px;font-size: 1.8rem;text-align: center;">
            <div>
                <div (click)="pushDataToSelectedFieldsGrid()">
                    <em class="fas fa-step-forward" title="Move selected rows to
                Right"></em>
                </div>
                <div (click)="pushDataToSelectedFieldsGridComplete()">
                    <em class="fas fa-forward" title="Move all rows to
                Right"></em>
                </div>
                <div (click)="popDataToSelectedFieldsGridComplete()">
                    <em class="fas fa-backward" title="Move all rows to
                Left"></em>
                </div>
                <div (click)="popDataToSelectedFieldsGrid()">
                    <em class="fas fa-step-backward" title="Move selected rows to
                Left"></em>
                </div>
            </div>
        </div>


        <div *ngIf="addBtn" style="width: 76.5%;margin: 2px;">
            <div class="seperateDiv">
                <ag-grid-angular
                    class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
                    [columnDefs]="columnDefsForSelectedFields" [animateRows]="true" [defaultColDef]="defaultColDef"
                    [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true"
                    [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35"
                    [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true"
                    [debug]="true" [components]="components"
                    (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)"
                    (rowSelected)="onRowSelectedToRemove($event)" [hidden]="!true">
                </ag-grid-angular>
            </div>
        </div>
        <!-- <div class="col-2"></div> -->
    </div>
  
    <div *ngIf="!addBtn">
        <form novalidate >
             <div class="source-dns-container" >  
                <label style="font-weight: 500;
            font-size: medium;white-space: nowrap;padding-top: 8px;">Source DNS for Metadata:</label>
                <mat-form-field appearance="outline"  >
                    
                    <mat-label  i18n="@@RCFormulaexpression">Source DNS for Metadata</mat-label>
                    <mat-select title="Source DNS for Metadata" [(ngModel)]="sourceDns" required multiple
                        (selectionChange)="onSelectionSourceDNSForTemplate()" >
                        <mat-option [value]="null">None</mat-option>
                        <mat-option *ngFor="let source of listOfSourceDNS"
                          [value]="source.vaultConfigMstrId">{{source.envName}}</mat-option>
                    </mat-select>
                    <!-- <mat-error *ngFor="let validation of validation_messages.sourceDNS">
                        <span
                            *ngIf="validations_form.get('sourceDNS').hasError(validation.type) && (validations_form.get('sourceDNS').dirty || validations_form.get('sourceDNS').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error> -->
                </mat-form-field>
            </div> 
        <!-- <div class="col-3" style="display: flex;">
            <label style="font-weight: 500; font-size: medium; white-space: nowrap; padding-top: 8px;">
                Source DNS for Metadata:
            </label>
            <mat-form-field appearance="outline">
                <mat-label>Source DNS for Metadata</mat-label>
                <mat-select title="Source DNS for Metadata" [(ngModel)]="sourceDnsForUploadTemplate" name="sourceDNS" required disabled="false"
                    (selectionChange)="onSelectionSourceDNSForTemplate()">
        
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngFor="let source of listOfSourceDNS" [value]="source.vaultConfigMstrId">
                        {{ source.envName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->

<div style="display: flex; margin-bottom: 20px; ">
    <label style="font-weight: 500; font-size: medium; margin-left: 13px;">
        Download Object Group Template:
    </label>
    <button type="button" title="Download" (click)="downloadObjectGroupTemplate();"
        class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem; margin-left: 10px;">
        <i class="fas fa-download"></i>
    </button>
</div>
        <div style="display: flex;">
           
            <label style="font-weight: 500; font-size: medium; padding-top: 8px; margin-left: 13px;">
                Object Group Template:
            </label>
        
            <mat-form-field appearance="outline" style="width: 20%; padding-left: 2px; margin-top: 0px">
                <mat-label i18n="@@TMshoppingcomplexchooseimage">Choose File</mat-label>
                <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Choose File"
                    formControlName="imageName" id="imageName" [value]="selectedFileName" readonly disabled>
            </mat-form-field>
        
            <!-- Circular Paperclip Button -->
            <label for="imageupload" class="file-upload-label"
                [ngClass]="{'disabled-button': !dropdownSelected}" 
                [style.pointer-events]="dropdownSelected ? 'auto' : 'none'"
                style="cursor: pointer; display: flex; align-items: center;
                       justify-content: center; width: 32px; height: 32px;
                       border-radius: 50%; background-color: white;
                       border: 1px solid #ddd; box-shadow: 2px 2px 5px rgba(0,0,0,0.2); margin-left: 10px; margin-top: 5px;">
                <em class="fas fa-paperclip" style="color: black;"></em>
                <input type="file" id="imageupload" name="imageupload" 
                    (click)="resetFileInput($event)" 
                    (change)="onFileSelected($event)" formControlName="imageupload"
                    style="display: none;" [disabled]="!dropdownSelected">
            </label>
        </div>
        
        
    </form>
    </div>

   

    <div class="row mb-1 topRowMargins" style="left:0;bottom:0;width:100%;background-color: #fff; ">
        <div class="col-lg text-center">
            <div style="text-align: end">
                <form novalidate [formGroup]="formValidCheckbox">
                    <span *ngIf='buttonName=="Save" && addBtn'>
                        <mat-checkbox formControlName="isCheckboxSelected" ngDefaultControl
                            [(ngModel)]="isCheckboxSelected" class="mat-checkbox-layout"></mat-checkbox>
                        <span>
                            Create Another
                        </span>
                    </span>

                    <!-- <button *ngIf="addBtn" i18n="@@TMRunButton" [disabled]="false" type="button" (click)="save()"
                        class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                        style="padding-left:1.2rem;padding-right: 1.2rem"
                        [style.background-color]="backgroundColorButton"
                        [class.allocateButtons]="allocateButtonsBoolean"
                        [class.allocateButtons1]="allocateButtons1Boolean">Save</button> -->
                    
                    <app-common-button
                                    *ngIf="addBtn" i18n="@@TMRunButton" 
                                    label="Save"
                                    title="Save"
                                    [buttonId]="1111"
                                    width="110px"
                                    [critical]="false"
                                    (clicked)="save()"
                                    style="margin-left: 6px;margin-right:6px;"
                                    >
                     </app-common-button>



                        <!-- <button  *ngIf="!addBtn" i18n="@@TMRunButton"  type="button" (click)="uploadGroupTemplate()"
                        class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                        style="padding-left:1.2rem;padding-right: 1.2rem"
                        [style.background-color]="backgroundColorButton"
                        [class.allocateButtons]="allocateButtonsBoolean"
                        [class.allocateButtons1]="allocateButtons1Boolean" [disabled]="!(fileSelected && dropdownSelected)">Save</button> -->


                    <app-common-button
                            *ngIf="!addBtn" i18n="@@TMRunButton" 
                            label="Save"
                            title="Save"
                            [buttonId]="1111"
                            width="110px"
                            [critical]="false"
                            (clicked)="uploadGroupTemplate()"
                            style="margin-left: 6px;margin-right:6px;"
                            >
                    </app-common-button>
<!-- 
                    <button i18n="@@TMRunButton" type="button" (click)="cancel()"
                        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                        style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton"
                        [class.allocateButtons]="allocateButtonsBoolean"
                        [class.allocateButtons1]="allocateButtons1Boolean">Cancel</button>

                         -->
                        <app-common-button
                            label="Cancel"
                            title="Cancel "
                            [buttonId]="1111"
                            variant="cancel"
                            width="110px"
                            [critical]="false"
                            (clicked)="cancel()"
                            style="margin-left: 6px;margin-right:6px;"
                            >
                        </app-common-button>
                </form>
            </div>
        </div>
    </div>
</div>
